<template>
  <v-row justify="end" align="end" no-gutters style="height: 100%">
    <v-col cols="12" lg="12" xs="12">
      <!-- <v-row justify="end" align="end" no-gutters class="my-2"> -->
      <v-layout row wrap justify-end class="pa-1">
        <v-flex
          xs12
          v-if="
            product.promo == 1 ||
            product.favorite == 1 ||
            product.oo_new_product == 1 ||
            product.age_restricted != 0
          "
        >
          <v-layout row wrap justify-center class="pa-1">
            <v-flex v-if="product.promo == 1">
              <v-sheet
                v-if="product.promo == 1"
                class="white--text mx-auto pa-1"
                color="orange"
                >{{ promotionText }}</v-sheet
              >
            </v-flex>
            <v-flex v-if="product.favorite == 1">
              <v-sheet
                v-if="product.favorite == 1"
                class="white--text mx-auto pa-1"
                color="favourites"
                >Favourite</v-sheet
              >
            </v-flex>
            <v-flex v-if="product.oo_new_product == 1">
              <v-sheet
                v-if="parseInt(product.oo_new_product) == 1"
                class="white--text mx-auto pa-1"
                color="green darken-2"
                >New</v-sheet
              >
            </v-flex>
            <v-flex v-if="product.age_restricted != 0 && product.age_restricted != null">
              <v-sheet
                class="white--text mx-auto pa-1"
                color="red darken-2"
                >Age Restricted</v-sheet
              >
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- </v-col> -->
      </v-layout>
      <!-- </v-row> -->
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    product: {},
  },
  data() {
    return {
      tags: null,
    };
  },
  computed: {
    promotionText() {
      let promotionString = "Promotion";
      if (this.$store.getters.retrieveAllConfigs.promo_btn_text && this.$store.getters.retrieveAllConfigs.promo_btn_text != "") {
        promotionString = this.$store.getters.retrieveAllConfigs.promo_btn_text
      }

      if (this.$store.getters.retrieveAllConfigs.promo_showname) {
        if (
          parseInt(this.$store.getters.retrieveAllConfigs.promo_showname) == 1
        ) {
          promotionString += ": " + this.product.prom_name;
        }
      }

      return promotionString;
    },
  },
};
</script>

<style lang="sass" scoped>
*
  font-size: 14px
  text-align: center
</style>